import { resolveMedia } from "@/lib/api";
import { videoThumbUrl } from "@/lib/video";

/**
 * Renders a <picture> with WebP first (smaller, faster) and JPEG/PNG fallback.
 * - item: gallery item, may have webp_image, webp_thumbnail, image, thumbnail
 * - variant: "thumbnail" (default) | "full"
 * Videos with no stored poster fall back to the YouTube/Vimeo thumbnail.
 */
export default function Picture({ item, variant = "thumbnail", className, alt, loading, decoding }) {
  const webp = variant === "thumbnail"
    ? item.webp_thumbnail || item.webp_image
    : item.webp_image || item.webp_thumbnail;
  const jpeg = variant === "thumbnail"
    ? item.thumbnail || item.image
    : item.image || item.thumbnail;

  if (!jpeg) {
    const vthumb = item.type === "video" ? videoThumbUrl(item) : "";
    if (!vthumb) return null;
    return (
      <img
        src={vthumb}
        alt={alt || item.alt_text || item.title}
        className={className}
        loading={loading}
        decoding={decoding}
      />
    );
  }

  return (
    <picture>
      {webp && <source srcSet={resolveMedia(webp)} type="image/webp" />}
      <img
        src={resolveMedia(jpeg)}
        alt={alt || item.alt_text || item.title}
        className={className}
        loading={loading}
        decoding={decoding}
      />
    </picture>
  );
}
